import React from 'react';
import Layout from 'src/components/layout';
import { BreadcrumbsFactory } from 'src/components/layout/breadcrumbs';
import RecommendedPosts from 'src/components/post/recommended-posts/RecommendedPosts';
export var PageTemplate = function PageTemplate(_ref) {
  var title = _ref.title,
      content = _ref.content;
  return /*#__PURE__*/React.createElement("div", {
    className: "container content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "columns"
  }, /*#__PURE__*/React.createElement("div", {
    className: "column is-three-quarters"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "is-size-2 has-text-weight-bold is-bold-light"
  }, title), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "column"
  }, /*#__PURE__*/React.createElement(RecommendedPosts, null))));
};

var Page = function Page(_ref2) {
  var _page$title, _page$content;

  var data = _ref2.data;
  var page = data.wpPage;
  return /*#__PURE__*/React.createElement(Layout, {
    title: page === null || page === void 0 ? void 0 : page.title,
    breadcrumbs: [BreadcrumbsFactory.currentPage((page === null || page === void 0 ? void 0 : page.title) || '')]
  }, /*#__PURE__*/React.createElement(PageTemplate, {
    title: (_page$title = page === null || page === void 0 ? void 0 : page.title) !== null && _page$title !== void 0 ? _page$title : '',
    content: (_page$content = page === null || page === void 0 ? void 0 : page.content) !== null && _page$content !== void 0 ? _page$content : ''
  }));
};

export default Page;
export var pageQuery = "3418020804";